import '.g0{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.g1{padding-left:1.5rem;}.ssr-plugin'
import '.g2{margin:1rem 0;}.ssr-plugin'
import '.g3{color:var(--gray-700);}.ssr-plugin'
import '.g4{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="g0 g1 g2 g3 g4"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
